import*as r from"chrono-node";var o=e=>e instanceof Date?e:r.parseDate(e);export{o as a};
